import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MailBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/mail/feature","featureId":"common-mail"},
      abilityActions: false,
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'MailFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'MailFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      // {forPlatform:'admin', type:FeatureType.Permanent, pluginClassName:'MailFrontendAdminFeature'},
      {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MailBackendFeature'
      }
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'MailBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}